import { computed } from 'vue';

import store from '@/store';
import { StoreGetter, StoreAction } from '@/store/modules/StoreModuleService';

export function useStore() {
	const { dispatch, getters } = store;
	return {
		dispatch: <P, R>(action: StoreAction, payload: P, options?: Record<string, unknown>): Promise<R> =>
			dispatch(action.fullPath, payload, { ...options, root: true }),
		getter: <R>(getter: StoreGetter) => computed<R>(() => getters[getter.fullPath]),
	};
}
